'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ = require('..');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
	This component is typically meant to be used as a page-level header
*/
var PageHeader = function (_React$Component) {
	_inherits(PageHeader, _React$Component);

	function PageHeader() {
		_classCallCheck(this, PageHeader);

		return _possibleConstructorReturn(this, (PageHeader.__proto__ || Object.getPrototypeOf(PageHeader)).apply(this, arguments));
	}

	_createClass(PageHeader, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    title = _props.title,
			    className = _props.className,
			    children = _props.children;

			var classes = (0, _classnames2.default)(className, 'pg-header');
			return _react2.default.createElement(
				'div',
				{ className: classes },
				title && _react2.default.createElement(
					Section,
					{ align: 'left' },
					_react2.default.createElement(
						Title,
						null,
						title
					)
				),
				children
			);
		}
	}]);

	return PageHeader;
}(_react2.default.Component);

PageHeader.propTypes = {
	title: _propTypes2.default.string
};

/*
 * Divides the Page Header into sections that will expand/contract with the
 * window
 */
var Section = function Section(_ref) {
	var className = _ref.className,
	    children = _ref.children,
	    align = _ref.align,
	    compact = _ref.compact;

	var classes = (0, _classnames2.default)(className, {
		'pg-header-section': true,
		'is-left-aligned': align === 'left',
		'is-right-aligned': align === 'right',
		'is-center-aligned': align !== 'left' && align !== 'right',
		'is-compact': compact
	});
	return _react2.default.createElement(
		'div',
		{ className: classes },
		children
	);
};

Section.propTypes = {
	// Convenience prop for 'align-text: ...'
	align: _propTypes2.default.oneOf(['left', 'center', 'right']),
	// If set to true, this section will conform to the total width of its children
	compact: _propTypes2.default.bool
};

var Title = function (_React$Component2) {
	_inherits(Title, _React$Component2);

	function Title() {
		_classCallCheck(this, Title);

		return _possibleConstructorReturn(this, (Title.__proto__ || Object.getPrototypeOf(Title)).apply(this, arguments));
	}

	_createClass(Title, [{
		key: 'render',
		value: function render() {
			var _props2 = this.props,
			    children = _props2.children,
			    infoPopover = _props2.infoPopover,
			    id = _props2.id;
			// Accept raw elements

			var Overlay = void 0;
			if (infoPopover && (infoPopover.description || infoPopover.docLink)) {
				// render the Title contents as the popover title, unless a specific title has been set
				var props = _extends({
					title: children
				}, infoPopover);
				delete props.description;
				Overlay = _react2.default.createElement(
					_.PopOver,
					_extends({ id: id }, props),
					infoPopover.description || ''
				);
			} else if (infoPopover && typeof infoPopover === 'function') {
				// Accept render functions (react classes and the like)
				Overlay = infoPopover;
				Overlay = _react2.default.createElement(Overlay, null);
			} else if (_react2.default.isValidElement(infoPopover)) {
				// Accept react components
				Overlay = infoPopover;
			}
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					{ className: 'pg-header-title' },
					children
				),
				Overlay && _react2.default.createElement(
					_reactBootstrap.OverlayTrigger,
					{
						container: this,
						placement: 'right',
						trigger: 'click',
						containerPadding: 10,
						rootClose: true,
						overlay: Overlay
					},
					_react2.default.createElement(_reactBootstrap.Button, { className: 'pg-header-info gg icon-GG-info text' })
				)
			);
		}
	}]);

	return Title;
}(_react2.default.Component);

Title.propTypes = {
	infoPopover: _propTypes2.default.oneOfType([
	/*
 * This is a render function. It must return a React Element, specifically an
 * element acceptable by OverlayTrigger (Tooltip, Popover, etc.)
 */
	_propTypes2.default.func,
	/*
  * an element acceptable by OverlayTrigger (Tooltip, Popover, etc.)
  */
	_propTypes2.default.node,
	/*
  * Props for default popover. either docLink or description must be set for the popover to show
  */
	_propTypes2.default.shape({
		/*
   * Optional title for the popover if you don't want it to be the same as the titlebar content
   */
		title: _propTypes2.default.node,
		docLink: _propTypes2.default.string,
		description: _propTypes2.default.node
	})])
};

PageHeader.Section = Section;
PageHeader.Title = Title;
var _default = PageHeader;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(PageHeader, 'PageHeader', 'src/components/PageHeader.jsx');

	__REACT_HOT_LOADER__.register(Section, 'Section', 'src/components/PageHeader.jsx');

	__REACT_HOT_LOADER__.register(Title, 'Title', 'src/components/PageHeader.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/PageHeader.jsx');
}();

;